import React from "react";
import styles from "./ThankYou.scss";
import cx from "../../utils/cx";
import { IFinancialCheckData } from "./FinancialCheckPage";
import Button from "../MaterialUi/Button";
import LoginRegisterToggle from "../LoginRegisterToggle";
import useUser from "../../stores/useUser";
import JsonApiRequest, { IContact, IUser, PatchJsonObj } from "../../utils/JsonApiRequest";
import createToast from "../MaterialUi/Toast";
import JsonApiError from "../JsonApiError";
import {   mergeWith } from "lodash";
import CheckCircle from "../svg/CheckCircleOutlined"
import { IBaufiImplecoLeadPageProps } from "./BaufiImplecoLeadPage";


type IEditUser = Pick<IUser, 'date_of_birth' | 'type_of_employment' | 'net_income' | 'employed_since' | 'additional_monthly_income'>;



export interface IThankYouProps {
  className?: string;
  nextStep: () => void;
  setData: (data?: IFinancialCheckData) => void;
  data: IFinancialCheckData;
  prevStep?: () => void;
  variant?: IBaufiImplecoLeadPageProps['variant'];
}

const ThankYou: React.FC<IThankYouProps> = ({ className = '', data }) => {
    

    const [isSaving, setIsSaving] = React.useState(false);
    const [isSaved, setIsSaved] = React.useState(false);

    const [user] = useUser();

    console.log('user', user);

    const handleSaveData = (ev) => {
        ev.preventDefault();

        setIsSaving(true);

        const userData: PatchJsonObj<IEditUser> = {
            data: {
                type: 'user--user',
                id: user?.id,
                attributes: {
                    date_of_birth: data?.firstPerson?.birthday,
                    type_of_employment: data?.firstPerson?.typeOfEmployment,
                    net_income: data?.firstPerson?.monthlyNetIncomeInEuro.toString(),
                    employed_since: data?.firstPerson?.employedSince,
                    additional_monthly_income: data?.firstPerson?.additionalMonthlyIncome.toString(),
                },
            }
        };

        const patchUserPromise = JsonApiRequest.patchRequest<IEditUser>(`/user/user/${user?.id}`, userData)
            .then((data) => {
                // setOwner({ ...owner, [name]: value });
                // onSubmit();
                // return owner;
            })
            .catch((e) => {
                console.log('Error', e);
                createToast(<JsonApiError error={e} />, 'error');
            });



        const patchContactPromise = JsonApiRequest.getRequest(`/real_estate_contact/real_estate_contact?filter[user_id.id][value]=${user.id}&sort=drupal_internal__id`)
            .then((res) => {
                const currContactData = JsonApiRequest.data2Object<IContact>(res.getData()).find((e) => true);

                const firstPersonContactData  = {
                    mail: data?.firstPerson?.email,
                    field_address: {
                        given_name: data?.firstPerson?.firstName,
                        family_name: data?.firstPerson?.lastName,
                        postal_code: data?.firstPerson?.postalCode,
                        country_code: 'DE',
                    }
                };

                const mergeNotEmptyValues = (objValue, srcValue)=>{
                    if (objValue === "" || objValue === undefined || objValue === null) {
                        return srcValue;
                    }
                    return objValue;
                }

                const contactData: PatchJsonObj<IContact> = {
                    data: {
                        type: 'real_estate_contact--real_estate_contact',
                        id: currContactData?.id,
                        attributes: mergeWith(firstPersonContactData, currContactData?.attributes, mergeNotEmptyValues),
                    }
                };

                return JsonApiRequest.patchRequest<IContact>(`/real_estate_contact/real_estate_contact/${currContactData?.id}`, contactData)
                    .then((data) => {
                        // setOwner({ ...owner, [name]: value });
                        // onSubmit();
                        // return owner;
                        // console.log('Contact data saved', data);
                        // createToast('Deine Daten wurden gespeichert.', 'success');
                        return data;
                    })
                    .catch((e) => {
                        console.log('Error', e);
                        createToast(<JsonApiError error={e} />, 'error');
                    });
                

                // console.log(data);
                // return data;
            }).catch((e) => {
                console.error(e);
             
            }) 

        Promise.all([patchUserPromise, patchContactPromise])
            .then((res) => {
                console.log('All done', res);
                createToast('Deine Daten wurden gespeichert.', 'success');
                setIsSaved(true);
            })
            .catch((e) => {
                console.error(e);
                createToast(<JsonApiError error={e} />, 'error');
            })
            .finally(() => {
                setIsSaving(false);
            });

    }
    
    return <div className={cx(styles.thankYou, className)}>

        <h2>Super!</h2> 
        <p>
            Wir haben deine Anfrage übermittelt.<br /> 
            Dein persönlicher Finanzierungsberater wird sich in Kürze mit dir in Verbindung setzen.
        </p>

        <p>
            Um bei deiner Immobiliensuche auf Wohnglück.de für jede Immobilie schnell die Finanzierbarkeit zu überprüfen, 
            kannst du dich jetzt auf Wohnglück.de registrieren und deine Daten speichern.
        </p>

        { !user.isLoggedIn && <LoginRegisterToggle /> }
        { user.isLoggedIn && !isSaved && <p><Button onClick={handleSaveData} loading={isSaving}>Angaben im Profil speichern</Button></p> }
        { user.isLoggedIn &&  isSaved && <p><CheckCircle /></p> }

        {/* <div className={styles.actions}>
            <div></div>
            <Button variant="text" href={`/property/${data.property?.uid}`} endIcon={<Icon name="navigateNext" />}>zum Exposé zurück</Button>
        </div> */}

    </div>
};

export default ThankYou;
